import { sortingDirection, SortingDirection } from "../../app/constants/sortingData";

export const sortArrayOfObjects = <T>(data: T[], keyToSort: keyof T, direction: SortingDirection) => {
    if (data.length < 1) return [];
    if (direction === sortingDirection.none) {
        return data;
    }

    return [...data].sort((objectA, objectB) => {
        const valueA = objectA[keyToSort];
        const valueB = objectB[keyToSort];

        // Handle missing values
        if (valueA == null || valueB == null) return 0;

        // Date comparison
        if (valueA instanceof Date && valueB instanceof Date) {
            return direction === sortingDirection.asc
                ? valueA.getTime() - valueB.getTime()
                : valueB.getTime() - valueA.getTime();
        }

        // String comparison
        if (typeof valueA === "string" && typeof valueB === "string") {
            return direction === sortingDirection.asc ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
        }

        // Numeric comparison
        if (typeof valueA === "number" && typeof valueB === "number") {
            return direction === sortingDirection.asc ? valueA - valueB : valueB - valueA;
        }

        return 0; // Default case (if types don't match)
    });
};
